import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'totalFileSize',
    standalone: false
})
export class TotalFileSizePipe implements PipeTransform {
  transform(bytes: number): string {
    if (bytes === 0) { return '0 Bytes'; }
    const  decimals = 2;
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}